import Application from '@ember/application';
import Intercom from '@intercom/messenger-js-sdk';
import Ember from 'ember';
import { extendResolver } from 'ember-can';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import config from 'garaje/config/environment';
import isPhone from 'garaje/utils/is-phone';
import 'moment-timezone'; // to use moment with timezone
import $ from 'jquery';

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = extendResolver(Resolver);

  Intercom?: unknown;

  constructor(options?: object) {
    super(options);

    if (config.intercomAppId && !isPhone()) {
      this.Intercom = Intercom({
        app_id: config.intercomAppId,
        hide_default_launcher: false,
      });
    }
  }

  // @ts-expect-error - TS wants `ready = function () { ... }`
  ready(): void {
    if (config.isCypress && !window.Ember) {
      // we need this, because cypress tests are expecting Ember global in window
      window.Ember = Ember;
    }

    window.global = window; // for rome package

    // cancels the loading timer when app is completely ready to go - initializer doesn't work b/c we have deferReadiness for google maps
    window.clearTimeout(window.loadingTimer);

    // Disable some eslint rules for these lines because jQuery is involved
    /* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, ember/no-jquery */
    const loadingMessage = $('.load-error');
    if (loadingMessage.first()) {
      loadingMessage.first().removeClass('display');
    }
    /* eslint-enable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, ember/no-jquery */

    window.appStartTime = performance.now();
    window.appMeasurementTaken = false;
  }
}

loadInitializers(App, config.modulePrefix);
